export const hasFinancialIndicators = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_FINANCIAL_INDICATORS' && !!permission.status,
  );
};
